function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavaScriptLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1800pt",
    height: "1799.999925pt",
    viewBox: "0 0 1800 1799.999925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.918762%,0%)",
      fillOpacity: 1
    },
    d: "M 180 180 L 1620 180 L 1620 1620 L 180 1620 Z M 180 180 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0.389099%)",
      fillOpacity: 1
    },
    d: "M 1121.519531 1257.878906 C 1149.199219 1302.839844 1179.28125 1345.917969 1243 1345.917969 C 1296.519531 1345.917969 1324.601562 1319.320312 1324.601562 1282.519531 C 1324.601562 1238.480469 1295.558594 1222.839844 1236.679688 1197.199219 L 1204.398438 1183.441406 C 1111.238281 1143.917969 1049.28125 1094.398438 1049.28125 989.800781 C 1049.28125 893.398438 1123.078125 820.039062 1238.398438 820.039062 C 1320.519531 820.039062 1379.519531 848.480469 1422.078125 922.960938 L 1321.519531 987.238281 C 1299.398438 947.71875 1275.480469 932.160156 1238.398438 932.160156 C 1200.558594 932.160156 1176.601562 956.039062 1176.601562 987.238281 C 1176.601562 1025.800781 1200.601562 1041.398438 1256 1065.28125 L 1288.28125 1079.039062 C 1398.078125 1125.800781 1460 1173.558594 1460 1280.917969 C 1460 1396.601562 1368.640625 1460 1246 1460 C 1126.039062 1460 1057.921875 1399.800781 1020 1325.28125 Z M 658.078125 1261.160156 C 678.320312 1297.398438 709.078125 1325.28125 753.320312 1325.28125 C 795.640625 1325.28125 820 1308.558594 820 1243.558594 L 820 820 L 953.320312 820 L 953.320312 1264.039062 C 953.320312 1398.71875 875.199219 1460 761.121094 1460 C 658.039062 1460 583.640625 1390.160156 553.320312 1325.28125 Z M 658.078125 1261.160156 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavaScriptLogo);
export default __webpack_public_path__ + "static/media/JavaScriptLogo.f4e00ef8b082a148725feafbdba3be4b.svg";
export { ForwardRef as ReactComponent };